import React, { useEffect, useState, lazy, Suspense, useCallback } from "react";
import { BrowserRouter, Route, Routes } from "react-router-dom";

import { Toaster } from "./components/ui/toaster";
import ScrollToTop from "./components/sections/ScrollToTop";

import {
  server_post_data,
  get_seo_data_website,
} from "./ServiceConnection/serviceconnection";

// =========================
// Lazy Loaded Pages
// =========================

const Home = lazy(() => import("./pages/Home"));
const About = lazy(() => import("./pages/About"));
const Services = lazy(() => import("./pages/Services"));
const Blog = lazy(() => import("./pages/Blog"));
const Contact = lazy(() => import("./pages/Contact"));
const BlogDetail = lazy(() => import("./pages/BlogDetail"));
const ServiceDetail = lazy(() => import("./pages/ServiceDetail"));
const PrivacyPolicy = lazy(() => import("./pages/PrivacyPolicy"));
const TermsAndConditions = lazy(() => import("./pages/TermsAndConditions"));
const NotFound = lazy(() => import("./pages/NotFound"));

const routeMap = {
  "/": "1",
  "/about": "2",
  "/services": "3",
  "/blog": "4",
  "/blog/category/:categorySlug": "4",
  "/contact": "5",
};

function App() {
  const [SEOloop, setSEOloop] = useState([]);

  const fetchSEO = useCallback(async () => {
    try {
      const cache = sessionStorage.getItem("seo_routes");

      if (cache) {
        setSEOloop(JSON.parse(cache));
        return;
      }

      const response = await server_post_data(get_seo_data_website, null);

      if (!response.data.error) {
        const routes = response.data.message.seo_loop;

        setSEOloop(routes);

        sessionStorage.setItem("seo_routes", JSON.stringify(routes));
      }
    } catch (err) {
      console.log(err);
    }
  }, []);

  useEffect(() => {
    fetchSEO();
  }, [fetchSEO]);

  const getPage = (page) => {
    switch (page) {
      case "1":
        return <Home />;

      case "2":
        return <About />;

      case "3":
        return <Services />;

      case "4":
        return <Blog />;

      case "5":
        return <Contact />;

      case "6":
        return <BlogDetail />;

      default:
        return <NotFound />;
    }
  };

  return (
    <BrowserRouter>
      <Toaster />
      <ScrollToTop />

      <Suspense
        fallback={
          <div
            style={{
              minHeight: "100vh",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            Loading...
          </div>
        }
      >
        <Routes>
          {/* Static Routes */}

          <Route path="/" element={<Home />} />

          <Route path="/about" element={<About />} />

          <Route path="/services" element={<Services />} />

          <Route path="/blog" element={<Blog />} />

          <Route path="/blog/category/:categorySlug" element={<Blog />} />

          <Route path="/blog/:slug" element={<BlogDetail />} />

          <Route path="/contact" element={<Contact />} />

          <Route path="/services/:serviceSlug" element={<ServiceDetail />} />

          <Route path="/privacy-policy" element={<PrivacyPolicy />} />

          <Route
            path="/terms-and-conditions"
            element={<TermsAndConditions />}
          />

          {/* Dynamic SEO Routes */}

          {SEOloop.map((item, index) => {
            const page = routeMap[item.call_function_name];

            if (!page) return null;

            return (
              <Route
                key={index}
                path={item.call_function_name}
                element={getPage(page)}
              />
            );
          })}

          {/* 404 */}

          <Route path="*" element={<NotFound />} />
        </Routes>
      </Suspense>
    </BrowserRouter>
  );
}

export default App;
